import React from "react";
import LogicaAgregarCliente from "./LogicaAgregarCliente";

const Agregar = () => {
  return <LogicaAgregarCliente />;
};

export default Agregar;
